import React, { useContext } from "react";
import { Typography } from "@material-ui/core";

import { CardContext } from "../../../context/CardContext";
import { AuthContext } from "../../../../../../contexts/AuthContext";
import { css } from "./styles";

export function Atributos({ atributos }) {
    const {
        alfa,
        nome_produto,
        id_produto,
        departamento,
        linha,
        grupo,
        nome_fornecedor,
        status,
        dt_atlz,
    } = atributos;

    const { tipo_card } = useContext(CardContext);
    const {
        user: { isVisaoTok },
    } = useContext(AuthContext);
    const styles = css();

    const date = new Date(dt_atlz);
    const dataAtualizacao = date.toLocaleDateString("pt-br");

    return (
        <>
            <Typography variant="h2" className={styles.h2}>
                Alfa numérico: {alfa}
            </Typography>

            <Typography>Nome do produto: {nome_produto}</Typography>

            <Typography>ID do produto: {id_produto}</Typography>

            <Typography>Departamento: {departamento}</Typography>

            <Typography>Linha: {linha}</Typography>

            <Typography>Grupo: {grupo}</Typography>

            <Typography>Fornecedor: {nome_fornecedor}</Typography>

            {isVisaoTok && <Typography>Status: {status}</Typography>}

            {isVisaoTok && dt_atlz !== "0001-01-01T00:00:00" && <Typography>Atualização: {dataAtualizacao}</Typography>}
        </>
    );
}
